import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { checkValidity, checkFormValidity } from '../../store/Utility';

import Aux from '../../hoc/Auxiliary';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';

import classes from './SignUp.module.css';

class SignUp extends Component {
    state = {
        newUser: {
            name: {
                label: 'Full Name',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Full Name'
                },
                value: '',
                validation: {
                    required: true
                },
                valid: false,
                touched: false
            },
            gender: {
                label: "Gender",
                elementType: 'select',
                elementConfig: {
                    options: [
                        { value: 'female', displayValue: 'Female' },
                        { value: 'male', displayValue: 'Male' },
                        { value: 'other', displayValue: 'Other' }
                    ]
                },
                value: 'female',
                validation: {
                    required: true
                },
                valid: true,
                touched: false

            },
            email: {
                label: 'Email',
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true
                },
                valid: false,
                touched: false
            },
            password: {
                label: 'Password',
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            },
            passwordDuplicate: {
                label: 'Please Repeat Password',
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 5
                },
                valid: false,
                touched: false
            },
            phone: {
                label: 'Phone Number',
                elementType: 'input',
                elementConfig: {
                    type: 'tel',
                    placeholder: '(###)###-####'
                },
                value: '',
                validation: {
                    required: true,
                    isPhone: true
                },
                valid: false,
                touched: false
            },
            group: {
                label: "Group",
                elementType: 'select',
                elementConfig: {
                    options: [
                        { value: 'community', displayValue: 'Community' },
                        { value: 'delgadoStudent', displayValue: 'Delgado Student' },
                        { value: 'delgadoStaff', displayValue: 'Delgado Staff' },
                        { value: 'delgadoTeacher', displayValue: 'Delgado Teacher' },
                        { value: 'fabLabStaff', displayValue: 'FabLab Staff' },
                        { value: 'k12Mentor', displayValue: 'K-12 Mentor' },
                        { value: 'k12Teacher', displayValue: 'K-12 Teacher' }
                    ]
                },
                value: 'commmunity',
                validation: {
                    required: true
                },
                valid: true,
                touched: false
            },
            organization: {
                label: 'Organization',
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    placeholder: 'Organization'
                },
                value: '',
                validation: {
                    required: false
                },
                valid: false,
                touched: false
            },
        }
    }

    submitHandler = ( event ) => {
        event.preventDefault();
        const isValid = checkFormValidity( this.state.newUser );
        if( isValid[ 0 ] ) {
            if( this.state.newUser.password.value === this.state.newUser.passwordDuplicate.value ) {
                const email = this.state.newUser.email.value;
                const password = this.state.newUser.password.value;
                const user = {
                    name: this.state.newUser.name.value,
                    email: this.state.newUser.email.value,
                    gender: this.state.newUser.gender.value,
                    phone: this.state.newUser.phone.value,
                    group: this.state.newUser.group.value,
                    organization: this.state.newUser.organization.value,
                    role: 'user',
                    permissions: [],
                    lastLogin: new Date()
                }
                this.props.onSignUp( user, password );
            } else {
                this.props.onLoadMessage( 'Passwords Must Match', 'error' );
            }
        } else {
            this.props.onLoadMessage( isValid[ 1 ], 'error' );
        }
    }

    inputChangedHandler = ( event, inputId ) => {
        const updatedForm = { ...this.state.newUser };
        const updatedElement = { ...updatedForm[ inputId ] };
        updatedElement.value = event.target.value;
        updatedElement.valid = checkValidity( event.target.value, this.state.newUser[ inputId ].validation );
        updatedElement.touched = true;
        updatedForm[ inputId ] = updatedElement;
        this.setState( { newUser: updatedForm } );
    }

    render () {
        const formElementArray = [];
        for( let key in this.state.newUser ) {
            formElementArray.push( {
                id: key,
                config: this.state.newUser[ key ]
            } );
        }

        let form = ( <Aux>
            {
                formElementArray.map( formElement => (
                    <Input
                        changed={( event ) => this.inputChangedHandler( event, formElement.id )}
                        key={formElement.id}
                        elementId={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        label={formElement.config.label}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                    />
                ) )
            }
        </Aux> );

        return (
            <div className={classes.Box}>
                <form className={classes.Form} onSubmit={this.submitHandler}>
                    {form}
                    <Button clicked={this.submitHandler}>SIGN UP</Button>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSignUp: ( user, password ) => dispatch( actions.createFirebaseUser( user, password ) ),
        onLoadMessage: ( message, style ) => dispatch( actions.setMessages( message, style ) )
    }
}

export default connect( mapStateToProps, mapDispatchToProps )( SignUp );